import type { RiskLevel } from '@nestjs-boilerplate/types';

import { DateFilter, type DateFilterValue } from './date-filter';
import { ReportWindowFilter, type ReportWindowOption } from './report-window-filter';
import { RiskLevelFilter } from './risk-level-filter';
import { SearchInput } from './search-input';

export interface FilterState {
  search: string;
  dateFilter: DateFilterValue;
  riskLevels: RiskLevel[];
  reportWindow: ReportWindowOption[];
}

interface FilterBarProps {
  filters: FilterState;
  onFiltersChange: (filters: FilterState) => void;
  totalResults: number;
}

export function FilterBar({ filters, onFiltersChange, totalResults }: FilterBarProps) {
  const hasActiveFilters =
    filters.search ||
    filters.dateFilter.preset !== 'this_month' ||
    filters.riskLevels.length > 0 ||
    filters.reportWindow.length > 0;

  const handleClearFilters = () => {
    onFiltersChange({
      search: '',
      dateFilter: { preset: 'this_month' },
      riskLevels: [],
      reportWindow: [],
    });
  };

  return (
    <div className="flex flex-wrap items-center gap-4">
      <SearchInput
        value={filters.search}
        onChange={(search) => onFiltersChange({ ...filters, search })}
      />

      <DateFilter
        value={filters.dateFilter}
        onChange={(dateFilter) => onFiltersChange({ ...filters, dateFilter })}
      />

      <RiskLevelFilter
        value={filters.riskLevels}
        onChange={(riskLevels) => onFiltersChange({ ...filters, riskLevels })}
      />

      <ReportWindowFilter
        value={filters.reportWindow}
        onChange={(reportWindow) => onFiltersChange({ ...filters, reportWindow })}
      />

      {hasActiveFilters && (
        <button
          type="button"
          onClick={handleClearFilters}
          className="text-[14px] text-[#051923] underline hover:no-underline"
        >
          Clear all filters
        </button>
      )}

      <div className="ml-auto text-[14px] text-muted-foreground">{totalResults} Results</div>
    </div>
  );
}
